/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AddressBookResponse } from '../../models/address-book-response';
import { BaseResponse } from '../../models/base-response';

export interface AddressBookControllerGetAll$Params {
  query?: string;
  registry_id?: number;
  registry_office_id?: number;
  limit: number;
  skip: number;
  contact_ids?: Array<number>;
}

export function addressBookControllerGetAll(http: HttpClient, rootUrl: string, params: AddressBookControllerGetAll$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: AddressBookResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, addressBookControllerGetAll.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('registry_id', params.registry_id, {});
    rb.query('registry_office_id', params.registry_office_id, {});
    rb.query('limit', params.limit, {});
    rb.query('skip', params.skip, {});
    rb.query('contact_ids', params.contact_ids, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: AddressBookResponse;
      }>;
    })
  );
}

addressBookControllerGetAll.PATH = '/address-book';
